import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import PurchaseMotionButtonWrapper from 'pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper';
import { activeCurrencySelector } from 'pricing-pages-ui/selectors/CurrencySelectors';
import { APP, SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';

const SuiteAuthedCTAs = ({
  productLevel,
  buttonUses,
  trackingSource,
  queryParamTerm,
  purchaseMotions,
  ctaStyles = {},
  isEbx633
}) => {
  const productConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const activeCurrency = useSelector(activeCurrencySelector);
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: productConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const upgradeData = {
    app: APP,
    screen: isEbx633 ? SCREENS.SUITE_STARTER : SCREENS.PRODUCTS_PLANS,
    uniqueId: `${trackingSource}-${productLevel.toLowerCase()}`,
    upgradeProduct
  };
  const nonMerchandiseIdIdentifier = SuiteProductLevelIdentifiersMap[productLevel];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: purchaseMotions.map((_, index) => /*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
      use: index === 0 ? buttonUses[0] : buttonUses[1],
      level: index + 1,
      className: `m-left-0 ${!isEbx633 && 'm-bottom-2'}`,
      purchaseMotions: purchaseMotions,
      upgradeData: upgradeData,
      productConfigurations: productConfigurations,
      currencyCode: activeCurrency,
      productBasedOffers: [],
      trackingSource: trackingSource,
      nonMerchandiseIdIdentifier: nonMerchandiseIdIdentifier,
      queryParamTerm: queryParamTerm,
      style: ctaStyles
    }, purchaseMotions[index]))
  });
};

export default SuiteAuthedCTAs;